export default __webpack_public_path__ + "static/media/icon-put-active.d85cad03.svg";